export const SeaLogActionTypes = {
  API_RESPONSE_SUCCESS: '@@sea-logs/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@sea-logs/API_RESPONSE_ERROR',

  GET_SEA_LOG: '@@sea-logs/GET_SEA_LOG',
  LIST_SEA_LOGS: '@@sea-logs/LIST_SEA_LOGS',
  ADD_SEA_LOG: '@@sea-logs/ADD_SEA_LOG',
  UPDATE_SEA_LOG: '@@sea-logs/UPDATE_SEA_LOG',
  DELETE_SEA_LOG: '@@sea-logs/DELETE_SEA_LOG',
  SET_FILTER: '@@sea-logs/SET_FILTER',

  RESET: '@@sea-logs/RESET'
}
